export default "__VITE_ASSET__CZ8fahlf__"